import { COLORS, FONTS, SIZE } from '@app/src/ui';
import styled from 'styled-components';

const ROOT = 'Home/listProducts/CategorySlider';

export const Wrapper = styled.section`
  background: #F0F0F0;
  padding: 50px 0;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 97px 0;
  }
`;

Wrapper.className = `${ROOT}/Wrapper`;

export const Text = styled.div`
  font-size: 24px;
  color: ${COLORS.BLACK};
  font-family: ${FONTS.MONTSERRAT};
  margin-bottom: 24px;
`;

Text.className = `${ROOT}/Text`;

export const Container = styled.div`
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;

  & > ${Text} {
    display: block;
  }

  @media (min-width: ${SIZE.LARGE_DESKTOP}) {
    padding: 0;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    & > ${Text} {
      display: none;
    }
  }
`;

Container.className = `${ROOT}/Container`;

export const LabelAnnouncement = styled.span`
  display: inline-block;
  color: ${COLORS.RED_HIGHLIGHT};
  border: 1px solid ${COLORS.RED_HIGHLIGHT};
  border-radius: 4px;
  line-height: 42px;
  width: 212px;
  margin-bottom: 20px;
  background: #fff;
  font-size: 14px;
  text-align: center;
  font-family: ${FONTS.ROBOTO_BOLD};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 240px;
    font-size: 16px;
  }
`;

LabelAnnouncement.className = `${ROOT}/LabelAnnouncement`;

export const Title = styled.h3`
  font-family: ${FONTS.MONTSERRAT_BOLD};
  color: ${COLORS.BLACK_BOLD};
  font-size: 24px;
  max-width: 707px;
  margin-bottom: 48px;

  @madia (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 40px;
  }
`;

Title.className = `${ROOT}/Title`;

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  flex-direction: column-reverse;
  align-items: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0 54px;
    margin: 0;
    justify-content: center;
    flex-direction: row;
    align-items: flex-start;
  }
`;

Content.className = `${ROOT}/Content`;

export const Note = styled.span`
  font-family: ${FONTS.ROBOTO};
  font-size: 16px;
  color: ${COLORS.VIOLET};
`;

Note.className = `${ROOT}/Note`;

export const Description = styled.div`
  max-width: 410px;
  width: 100%;
  margin-right: 0px;
  text-align: center;

  & > ${Text} {
    display: none;
  }

  & > ${Note} {
    display: block;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    text-align: left;

    & > ${Text} {
      display: block;
    }

    & > ${Note} {
      display: none;
    }
  }

  @media (min-width: 950px) {
    margin-right: 80px;
  }
`;

Description.className = `${ROOT}/Description`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  & > ${Note} {
    display: none;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    & > ${Note} {
      display: block;
    }
  }

`;

ImageWrapper.className = `${ROOT}/ImageWrapper`;

export const Subtitle = styled.h4`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 22px;
  color: ${COLORS.VIOLET_HIGHLIGHT};
  margin-bottom: 24px;
`;

Subtitle.className = `${ROOT}/Subtitle`;

export const List = styled.ul`
  font-family: ${FONTS.ROBOTO};
  font-size: 20px;
  padding-left: 24px;
  text-align: left;
  margin-bottom: 20px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-bottom: 58px;
  }
`;

List.className = `${ROOT}/List`;

export const Item = styled.li`
  margin-bottom: 10px;
  list-style: disc;
`;

Item.className = `${ROOT}/Item`;

export const ImageCategory = styled.img`
  width: 100%;
  height: auto;
  border-radius: 16px;
  margin-bottom: 66px;
  max-width: 420px;
`;

ImageCategory.className = `${ROOT}/ImageCategory`;

export const ButtonPublish = styled.a`
  background: #000;
  color: #fff;
  font-family: ${FONTS.ROBOTO_BOLD};
  display: inline-block;
  border-radius: 5px;
  padding: 0 15px;
  width: 183px;
  font-size: 13px;
  text-align: center;
  line-height: 45px;
  margin-bottom: 24px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
    line-height: 52px;
    width: 262px;
    padding: 0 37px;
    margin-bottom: 0;
  }
`;

ButtonPublish.className = `${ROOT}/ButtonPublish`;

const IconWrapper = `
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconWrapperNext = styled.div`
  ${IconWrapper};
  transform: rotate(270deg);
`;

IconWrapperNext.className = `${ROOT}/IconWrapperNext`;

export const IconWrapperPrev = styled.div`
  ${IconWrapper};
  transform: rotate(90deg);
`;

IconWrapperPrev.className = `${ROOT}/IconWrapperPrev`;